export default "__VITE_ASSET__a7aix8mN__"